import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SwiperCarouselComponent } from './swiper-carousel.component';

@NgModule({
  declarations: [SwiperCarouselComponent],
  imports: [CommonModule, IonicModule],
  exports: [SwiperCarouselComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class SwiperCarouselModule {}
